import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  baseUrl = "https://datastudio.google.com/embed/reporting/1CsGTxFwsfLgmJqDCQB3Swt06qxAQUJfk/page";

  url: SafeUrl;

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.route.params.subscribe((params) => {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl + '/' + params.page);
    });


  }

}
